const CreatureKennzeichnungAnpassen = () => ({
    spezies:true,
    geschlechtsverhaeltnis:false,
    gewicht:true,
    groesse:true
}); 
export default CreatureKennzeichnungAnpassen;